export enum QUALTRICS_EVENTS {
  OPEN_MAP = 'OPEN_MAP'
}
